<template>
  <div class="charts-timeline">
    <div
      class="charts-timeline__tabs-period"
      :class="{ 'charts-timeline__tabs-period--disabled': isChartLoading }"
      :style="tabsPeriodStyleModifiers"
      v-show="tabsPeriod.length > 0 && !isLayoutMobile"
    >
      <tabs
        :activeTab="activeTabPeriod"
        :items="tabsPeriod"
        theme="timeline-sushi"
        @tabChange="tabChangePeriod"
      ></tabs>
    </div>
    <div
      class="charts-timeline__menu-control-stats"
      @click="onOpenStats"
      v-if="!isForStory"
      title="View trading statistics"
    ></div>
    <div class="charts-timeline__menu-control-settings" @click="onOpenSettings"></div>
    <div class="charts-timeline__logo"></div>
    <small-modal @modalClose="showMenu = false" v-if="showMenu">
      <template v-slot:header> Chart Settings </template>
      <template v-slot:content>
        <div class="charts-timeline__menu" v-if="showMenu">
          <div class="charts-timeline__menu-content">
            <template v-if="tabsPeriod.length > 0 && isLayoutMobile">
              <div class="charts-timeline__menu-label">Chart Timeline</div>
              <div class="charts-timeline__menu-inner">
                <div
                  class="charts-timeline__menu-inner-items"
                  :class="{ 'charts-timeline__menu-inner-items--disabled': isChartLoading }"
                >
                  <div
                    class="charts-timeline__menu-inner-item"
                    @click.prevent.stop="tabChangePeriod(tab.name)"
                    :class="{
                      'charts-timeline__menu-inner-item--selected': tab.name === activeTabPeriod,
                      'charts-timeline__menu-inner-item--disabled': isChartLoading,
                    }"
                    v-for="tab in tabsPeriod"
                    :key="tab.name"
                  >
                    {{ tab.title }}
                  </div>
                </div>
              </div>
              <hr />
            </template>
            <template v-if="tabsType.length > 1">
              <div class="charts-timeline__menu-label">Chart Type</div>
              <div class="charts-timeline__menu-inner">
                <div
                  class="charts-timeline__menu-inner-items"
                  :class="{ 'charts-timeline__menu-inner-items--disabled': isChartLoading }"
                >
                  <div
                    class="charts-timeline__menu-inner-item"
                    @click.prevent.stop="tabChangeType(tab.name)"
                    :class="{
                      'charts-timeline__menu-inner-item--selected': tab.name === activeTabType,
                      'charts-timeline__menu-inner-item--disabled': isChartLoading,
                    }"
                    v-for="tab in tabsType"
                    :key="tab.name"
                  >
                    {{ tab.title }}
                  </div>
                </div>
              </div>
              <hr />
            </template>
            <div class="charts-timeline__menu-label">Chart Settings</div>
            <div class="charts-timeline__menu-inner">
              <div
                class="charts-timeline__toggle"
                :class="{ 'charts-timeline__toggle--disabled': isChartLoading }"
              >
                <div
                  class="charts-timeline__toggle-control"
                  :class="{
                    'charts-timeline__toggle-control--active': showVolumeChart,
                    'charts-timeline__toggle-control--disabled': isChartLoading,
                  }"
                  @click.prevent.stop="onVolumeChartToggle"
                ></div>
                <div class="charts-timeline__toggle-control-label">Show Volume</div>
              </div>
            </div>
            <div class="charts-timeline__menu-inner">
              <div
                class="charts-timeline__toggle"
                :class="{ 'charts-timeline__toggle--disabled': isChartLoading }"
              >
                <div
                  class="charts-timeline__toggle-control"
                  :class="{
                    'charts-timeline__toggle-control--active': showPriceAxisZoomValue,
                    'charts-timeline__toggle-control--disabled': isChartLoading,
                  }"
                  @click.prevent.stop="onPriceAxisZoomToggle"
                ></div>
                <div class="charts-timeline__toggle-control-label">Price Axis Zoom</div>
              </div>
            </div>
            <template v-if="!isForStory">
              <hr />
              <div
                class="charts-timeline__menu-stats"
                :class="{ 'charts-timeline__menu-stats--disabled': isChartLoading }"
                @click.prevent.stop="onOpenStats"
              >
                Open Stats
              </div>
            </template>
            <div class="charts-timeline__menu-loading" v-if="isChartLoading">
              <div class="charts-timeline__menu-loading-spinner"></div>
            </div>
          </div>
          <hr />
          <button
            class="button button--large button--black button--full-width"
            @click="showMenu = false"
          >
            Close
          </button>
        </div>
      </template>
    </small-modal>
  </div>
</template>

<script src="./timeline.js"></script>
<style src="./timeline.scss" lang="scss"></style>
